export default "ui-chart-options{display:none}\n";